module.exports = __webpack_public_path__ + "static/assets/b1f026ce265c0f666e2063ef94b06109.svg";